'use client'

import useWebviewBridge from '@/store/bridge'
import Link from 'next/link'
import React, { MouseEvent } from 'react'
import { useDialogStore } from './dialog/FullScreenBackDrop'
import { useAuthStore } from '@/store/auth'
import { usePathname, useRouter } from 'next/navigation'
import { useTopLoader } from './@fork/NextTopLoader'
import classNames from 'classnames'

type Props = {
  href?: string
  children: React.ReactNode
  external?: boolean
  privilege?: boolean
  className?: string
  onClick?: (e: MouseEvent) => void
  style?: React.CSSProperties
  disabled?: boolean
}

export const GenericLink = ({
  href,
  children,
  external,
  privilege,
  className,
  onClick,
  style,
  disabled,
}: Props) => {
  const bridge = useWebviewBridge()
  const dialog = useDialogStore()
  const auth = useAuthStore()
  const router = useRouter()
  const pathname = usePathname()
  const loader = useTopLoader()

  const onClickLink = (e: MouseEvent) => {
    e.stopPropagation()

    if (privilege) {
      if (auth.user?.status !== 'ACTIVE') {
        e.preventDefault()
        if (window.innerWidth < 900) {
          router.push(`/auth/signin?redirect=${pathname}`)
        } else {
          dialog.push('login')
        }

        loader.done()
        return
      }
    }

    onClick?.(e)

    if (href) {
      if (external) {
        e.preventDefault()
        bridge.openExtenalLink(href)
        loader.done()
      }
    }
  }

  const onClickButton = (e: MouseEvent) => {
    e.nativeEvent.stopImmediatePropagation()

    if (privilege) {
      e.preventDefault()
      if (auth.user?.status !== 'ACTIVE') {
        if (window.innerWidth < 900) {
          router.push(`/auth/signin?redirect=${pathname}`)
        } else {
          dialog.push('login')
        }
        return
      }
    }

    onClick?.(e)
  }

  if (disabled) {
    return (
      <button
        className={classNames(className, 'cursor-pointer')}
        style={style}
        disabled
      >
        {children}
      </button>
    )
  }

  if (!href) {
    return (
      <div
        onClick={onClickButton}
        className={classNames(className, 'cursor-pointer')}
        style={style}
      >
        {children}
      </div>
    )
  }

  return (
    <Link href={href} onClick={onClickLink} className={className} style={style}>
      {children}
    </Link>
  )
}
